/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_bZ_98_90 as Componente_bZ_98_90,
  rec_Componente_xZ_120_90 as Componente_xZ_120_90,
  rec_EstadoError as EstadoError,
  rec_FormularioCatalogoMovilidad as FormularioCatalogoMovilidad,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_Ti as Ti,
  rec_api as api,
  rec_wi as wi,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function Componente__Z_95_90({
  titulo: e,
  descripcion: t,
  recurso: n,
  nuevoLabel: r,
  placeholder: i,
}) {
  let a = Go(),
    [o, s] = (0, React.useState)([]),
    [c, l] = (0, React.useState)(!0),
    [u, f] = (0, React.useState)(``),
    [p, m] = (0, React.useState)(null),
    h = (0, React.useCallback)(async () => {
      l(!0);
      try {
        (s(await api(`/transporte/${n}`)), f(``));
      } catch (e) {
        f(e.message);
      } finally {
        l(!1);
      }
    }, [n]);
  return (
    (0, React.useEffect)(() => {
      h();
    }, [h]),
    (
      <section
        className={`${Bo} flex flex-col gap-3`}
        children={[
          <div
            className={`flex items-start justify-between gap-3`}
            children={[
              <div
                children={[
                  <p className={`font-medium text-(--text-h)`} children={e} />,
                  <p className={`text-sm text-(--text)`} children={t} />,
                ]}
              />,
              <button
                type={`button`}
                onClick={() => m({})}
                className={zo}
                children={[
                  <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                  ` `,
                  r,
                ]}
              />,
            ]}
          />,
          <EstadoError mensaje={u} onReintentar={h} />,
          c ? (
            <Componente_bZ_98_90 />
          ) : o.length === 0 ? (
            <Componente_xZ_120_90
              texto={`Todavía no hay ${e.toLowerCase()}.`}
            />
          ) : (
            <ul
              className={`flex flex-wrap gap-2`}
              children={o.map((e) => (
                <li
                  key={e.id}
                  className={`flex items-center gap-2 rounded-xl border border-(--border) py-2 pl-3 pr-2 ${e.activo ? `` : `opacity-60`}`}
                  children={[
                    <span
                      className={`text-sm text-(--text-h)`}
                      children={e.nombre}
                    />,
                    !e.activo && (
                      <span
                        className={`text-[10px] uppercase text-(--text)`}
                        children={`inactivo`}
                      />
                    ),
                    <button
                      type={`button`}
                      onClick={() =>
                        m({
                          editar: e,
                        })
                      }
                      aria-label={`Editar ${e.nombre}`}
                      className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                      children={(0, JSXRuntime.jsx)(wi, {
                        className: `h-3.5 w-3.5`,
                      })}
                    />,
                  ]}
                />
              ))}
            />
          ),
          p && (
            <FormularioCatalogoMovilidad
              recurso={n}
              titulo={p.editar ? p.editar.nombre : r}
              placeholder={i}
              editar={p.editar}
              onClose={() => m(null)}
              onGuardado={() => {
                (m(null), a.ok(`Cambios guardados`), h());
              }}
            />
          ),
        ]}
      />
    )
  );
}
